const isProductionBuild = process.env.NODE_ENV === 'production';
export const isTargetingLocalServer = process.env.GATSBY_API_DOMAIN.includes("localhost");
const isStagingEnv = isProductionBuild && isTargetingLocalServer;
export const apiDomain = isStagingEnv ? "https://staging-api.maxer.io" : process.env.GATSBY_API_DOMAIN;
export const analyticsApi = `${apiDomain}/analytics`;
export const paymentsApi = `${apiDomain}/payments`;
export const adminApi = `${apiDomain}/admin`;

